export default theme => ({
  bulkText: {
    cursor: 'pointer'
  },
  cancelBtn: {
    position: 'relative',
    left: 167,
    top: -8
  }
});